import React from 'react';

export type SimpleButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  id?: string;
  'data-testid'?: string;
  'aria-label'?: string;
};

export const PrimaryCtaButton: React.FC<SimpleButtonProps> = ({ onClick, disabled, children, id, ...rest }) => (
  <button
    id={id}
    data-testid={rest['data-testid']}
    aria-label={rest['aria-label']}
    onClick={onClick}
    disabled={disabled}
    className="no-fastclick"
    style={{
      width: '100%',
      background: 'var(--primary-blue)',
      color: 'var(--common-white-main)',
      fontWeight: 600,
      borderRadius: 8,
      padding: '12px 16px',
      border: 'none',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.7 : 1
    }}
  >
    {children}
  </button>
);

export const OutlineCtaButton: React.FC<SimpleButtonProps> = ({ onClick, disabled, children, id, ...rest }) => (
  <button
    id={id}
    data-testid={rest['data-testid']}
    aria-label={rest['aria-label']}
    onClick={onClick}
    disabled={disabled}
    className="no-fastclick"
    style={{
      width: '100%',
      background: 'var(--common-white-main)',
      color: 'var(--primary-main)',
      border: '2px solid var(--primary-main)',
      fontWeight: 600,
      borderRadius: 8,
      padding: '12px 16px',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.7 : 1
    }}
  >
    {children}
  </button>
);

export const TextActionButton: React.FC<SimpleButtonProps> = ({ onClick, disabled, children }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className="no-fastclick"
    style={{
      color: 'var(--primary-blue)',
      background: 'transparent',
      border: 'none',
      padding: 0,
      fontSize: 14,
      fontWeight: 600,
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.7 : 1
    }}
  >
    {children}
  </button>
); 